/**
 * @module shouldRefreshClientConfiguration
 */

import store from '../store/store';
import {
    CLIENT_CONFIGURATION_VALIDITY,
    CLIENT_CONFIGURATION_ERROR_RETRY_DELAY,
} from '../constants';
import { ClientConfigurationCacheState } from '../store/schema/clientConfigurationCache';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * @function
 * This extra check for refreshing the client configuration is added as previously
 * the owa client version was sent in incorrect format, leading to themeMappings being
 * null. Hence, when this code hits the user, it forces OWA to refresh and populate
 * the localStorage with correct themeMappings, regardless of the data expiration time.
 * Otherwise, the user would have to wait for atmost 5 days, when the next refresh happens
 * and the localStorage is populated with correct data.
 * @returns { boolean } Whether the themeMappings stored in cache is null.
 */
const isThemeMappingsNull = (): boolean => {
    const themeMappingConnectors = store.cache.data?.themeMappings?.connectors;
    return (
        isFeatureEnabled('rp-actionableMessagesThemeConfig') &&
        store.cache.state === ClientConfigurationCacheState.Success &&
        themeMappingConnectors === null
    );
};

/**
 * @function
 * To check whether there is a need to refresh the client configuration or not
 * @returns whether the client configuration refresh is required or not
 */

const shouldRefreshClientConfiguration = (): boolean => {
    const lastFetchTimeSpan: number = Date.now() - store.cache.time;
    return (
        (store.cache.state === ClientConfigurationCacheState.Success &&
            lastFetchTimeSpan >= CLIENT_CONFIGURATION_VALIDITY) ||
        (store.cache.state === ClientConfigurationCacheState.Error &&
            lastFetchTimeSpan >= CLIENT_CONFIGURATION_ERROR_RETRY_DELAY) ||
        isThemeMappingsNull()
    );
};

export default shouldRefreshClientConfiguration;
